export enum UiCategoryEnum {
  ADAGIN = "Adagin",
  ADAGIN_LOGS = "Adagin Logs",
  ADAGIN_SYNC = "Trigger Adagin Sync",
  ADAGIN_SOURCE_FILES = "Adagin Source Files",
  AGRIGISTICS = "Agrigistics",
  AGRIGISTICS_LOGS = "Agrigistics Logs",
  AGRIGISTICS_SYNC = "Trigger Agrigistics Sync",
  AGRIGISTICS_SOURCE_FILES = "Agrigistics Source Files",
  PAYSPACE = "PaySpace",
  PAYSPACE_LOGS = "PaySpace Logs",
  PAYSPACE_SYNC = "Trigger PaySpace Sync",
  PAYSPACE_SOURCE_FILES = "PaySpace Source Files",
  MODERN_API = "Modern API",
  MODERN_API_SYNC = "Trigger Modern API Sync",
  BILLING = "Billing",
  BULK_ACTIONS = "Bulk Actions",
  CANDIDATES = "Candidates",
  COMING_SOON = "Coming soon",
  CONFIGURATOR = "Configurator",
  DOCUMENT_VALIDITY = "Document Validity",
  DATA_FIELDS = "Data Fields",
  DATA_FLOWS = "Data Flows",
  DATA_LOGS = "Data logs",
  DATA_QUERIES = "Data Queries",
  DATA_MANAGER = "Data Manager",
  DEVICE_LOGS = "Device logs",
  DISCIPLINE = "Discipline",
  DISCIPLINE_ALL = "All",
  DISCIPLINE_REPORT = "Discipline Report",
  DOCUMENTS = "Documents",
  EMPLOYEES = "Employees",
  EXPORT = "Export",
  EXPORT_PROFILES = "Export Profiles",
  EXPORT_DOC_VALIDITY_DATA = "Export doc validity data",
  EXPORT_DOCS = "Export Docs",
  EXPORT_EMPLOYEE_CARDS = "Export Employee Cards",
  FACE_SHOTS = "Faceshots",
  FORMS = "Forms",
  GLOBAL_LOGS = "Global Logs",
  GROUPS = "Groups",
  INTEGRATIONS = "Integrations",
  FILES_AND_PERFORMANCE_DATA_IMPORTS = "Files and Performance Data Imports",
  JSON_CONFIG_FILES = "Config Files",
  LOGIN = "Login",
  LOGS = "Logs",
  OPEN_REQUESTS = "Open Requests",
  PEOPLE = "People",
  PERFORMANCE = "Performance",
  PPE_CONFIG = "PPE",
  PPE_INVENTORY = "PPE Inventory",
  PROCESSES = "Processes",
  PROFILES = "Profiles",
  REQUESTS = "Requests",
  REQUESTS_PPE = "PPE Requests",
  REQUEST_HANDLER = "Requests",
  REPORTING = "Reporting",
  IMPORT = "Import",
  PROFILE_IMPORTS = "Bulk Profile Updates",
  TERMINATE = "Terminate",
  TRANSFER = "Transfer",
  TRASH = "Trash",
  USERS = "Users",
  UNDER_PERFORMANCE = "Under Performance",
}

export type SubMenuSchema = {
  label: string
  iconName?: string
  screenName: UiCategoryEnum
  hasAccess: boolean
}
export type SubSubMenuSchema = Record<UiCategoryEnum, SubMenuSchema[]>

export interface MenuSchema {
  label: string
  screenName: UiCategoryEnum
  subMenus: SubMenuSchema[] | []
  subSubMenus?: SubSubMenuSchema
}

export type NavMenuAccess = {
  hasDataLogsAccess?: boolean
  hasDeviceLogsAccess?: boolean
  hasDocExportAccess?: boolean
  hasDocValidityAccess?: boolean
  hasDocumentLibraryAccess: boolean
  hasImportAccess?: boolean
  hasRequestHandlerAccess?: boolean
  hasUserManagementAccess?: boolean
  hasCandidatesAccess?: boolean
  hasEmployeesAccess?: boolean
  hasTrashAccess?: boolean
  hasBulkTerminationAccess?: boolean
  hasBulkProfileImportAccess?: boolean
  hasBulkDisciplineAccess?: boolean
  hasDisciplineReportAccess?: boolean
  hasDataFlowConfigAccess?: boolean
  hasFieldConfigAccess?: boolean
  hasProcessConfigAccess?: boolean
  hasConfigUploadAccess?: boolean
  hasBillingAccess?: boolean
  hasJsonConfigFileAccess?: boolean
  hasGroupAccess?: boolean
  hasPpeStockAccess?: boolean
  hasPpeStockConfigAccess?: boolean
  hasPpeRequestAccess?: boolean
  hasAdvancedDataQueryAccess?: boolean
  hasExportAccess?: boolean
  hasAdaginAccess?: boolean
  hasAgrigisticsAccess?: boolean
  hasPaySpaceAccess?: boolean
  hasAdaginSyncTriggerAccess?: boolean
  hasAgrigisticsSyncTriggerAccess?: boolean
  hasPaySpaceSyncTriggerAccess?: boolean
  hasModernApiAccess?: boolean
  hasModernApiSyncTriggerAccess?: boolean
  hasAdaginLogDownloadAccess?: boolean
  hasAgrigisticsLogDownloadAccess?: boolean
  hasPaySpaceLogDownloadAccess?: boolean
  hasAdaginSourceFilesAccess?: boolean
  hasAgrigisticsSourceFilesAccess?: boolean
  hasPaySpaceSourceFilesAccess?: boolean
  hasFileAssociationAccess?: boolean
  hasPerformanceImportAccess?: boolean
}

export type ProfileNavMenuAccess = {
  hasDataManagerAccess: boolean
  hasFaceshotAccess: boolean
  hasDocPortalAccess: boolean
  hasPerformanceAccess: boolean
  hasDisciplineAccess: boolean
  hasLogsAccess: boolean
}
